import React, { useState } from 'react';
import styled from 'styled-components';
import { Accordion, Stack } from 'basis';
import NumberFormat from 'react-number-format';
import { BREAKPOINT } from '@latitude/core/utils/constants';
import queryString from 'query-string';
import { getUrlFromEnv } from '@/utils/getUrlFromEnvUtil';
import {
  SOFT_QUOTE_LOANS_AU_URL,
  SOFT_QUOTE_BROKER_URL,
} from '@/utils/constants';
import { getEstimateRateWidgetDefaults } from './utils';
import MainRateWidget, {
  purposeOptions,
  repaymentPeriodOptions
} from './MainRateWidget';
function EstimateRateWidget(props) {
  const {
    main,
    quote,
    result,
    stickyQuote,
    broker,
    showPurposeError,
    showPurposeErrorMessage,
    showPurposeOtherError,
    showPurposeOtherErrorMessage,
    showAmountMinError,
    showAmountMaxError,
    parentOnChangeEvent,
    isBetterStart,
  } = props;
  const {defaultPurpose, defaultLoanAmount, defaultRepaymentPeriod, defaultPurposeOther, defaultLoanPayFrequency } = getEstimateRateWidgetDefaults({
    isBroker:broker,
    isBetterStart,
    purpose: props?.values?.purpose,
    loans1: true
  });
  const [loanAmount, setLoanAmount] = useState( defaultLoanAmount );
  const [purpose, setPurpose] = useState( defaultPurpose);
  const [purposeOther, setPurposeOther] = useState( defaultPurposeOther);
  const [frequency, setFrequency] = useState(defaultLoanPayFrequency);
  const [repaymentPeriod, setRepaymentPeriod] = useState( defaultRepaymentPeriod );
  const [brokerFee, setBrokerFee] = useState(props.brokerFee ?? 0);


  function getSqBaseUrl({ isBroker }) {
    const softQuoteBaseUrl = getUrlFromEnv('funnel-start-loans');
    if (isBroker) {
      return `${softQuoteBaseUrl}${SOFT_QUOTE_BROKER_URL}`;
    }
    return `${softQuoteBaseUrl}${SOFT_QUOTE_LOANS_AU_URL}`;

  }

  function getFullSqUrl({ isBetterStart=false, isBroker=false }) {
    const options = {
      amount: loanAmount,
      purpose,
      period: repaymentPeriod,

    };
    if (isBetterStart) {
      options.subType = 'betterStart';
    }
    if (purpose === 'other' && purposeOther) {
      options.other = purposeOther
    }
    const partnerName = typeof window !== 'undefined' && sessionStorage.getItem('partnername');
    if (partnerName) {
      options.partnername = partnerName
    }
    return `${getSqBaseUrl({ isBroker })}?${queryString.stringify(options)}`;
  }
  const StyledPContent = styled.p`
    color: #006aff;
    font-size: 14px;
    padding: 0;
    margin: 0;
    line-height: 20px;
  `;

  const StyledPHeader = styled.p`
    color: #414141;
    font-size: 14px;
    padding: 0;
    margin: 0;
    line-height: 20px;
  `;

  const AmountFrequencyContainer = styled.div`
    @media (max-width: ${BREAKPOINT.SM}) {
      width: 22%;
    }
    @media (min-width: ${BREAKPOINT.SM}) {
      width: 33%;
    }
  `;

  const PurposeContainer = styled.div`
    @media (max-width: ${BREAKPOINT.SM}) {
      width: 56%;
    }
    @media (min-width: ${BREAKPOINT.SM}) {
      width: 33%;
    }
  `;

  const values = {
    loanAmount,
    purpose,
    purposeOther,
    frequency,
    repaymentPeriod,
    brokerFee
  };

  const updateValues = {
    setLoanAmount,
    setPurpose,
    setPurposeOther,
    setFrequency,
    setRepaymentPeriod,
    setBrokerFee
  };

  return (
    <>
      {stickyQuote && (
        <Accordion
          itemGap="small"
          color="secondary.lightBlue.t25"
          textColor="primary.blue.t100"
        >
          <Accordion.Item>
            <Accordion.Item.Header>
              <div style={{ display: 'flex', width: '100%' }}>
                <PurposeContainer>
                  <Stack>
                    <StyledPHeader>Purpose</StyledPHeader>
                    <StyledPContent>
                      <strong>
                        {
                          purposeOptions.filter(
                            purposeObj => purposeObj.value === purpose
                          )?.[0]?.text
                        }
                      </strong>
                    </StyledPContent>
                  </Stack>
                </PurposeContainer>
                <AmountFrequencyContainer>
                  <Stack>
                    <StyledPHeader>Amount</StyledPHeader>
                    <StyledPContent>
                      <strong>
                        <NumberFormat
                          value={loanAmount}
                          displayType="text"
                          thousandSeparator
                          prefix="$"
                        />
                      </strong>
                    </StyledPContent>
                  </Stack>
                </AmountFrequencyContainer>
                <AmountFrequencyContainer>
                  <Stack>
                    <StyledPHeader>Term</StyledPHeader>
                    <StyledPContent>
                      <strong>
                        {
                          repaymentPeriodOptions.filter(
                            repaymentPeriodObj =>
                              repaymentPeriodObj.value === repaymentPeriod
                          )?.[0]?.text
                        }
                      </strong>
                    </StyledPContent>
                  </Stack>
                </AmountFrequencyContainer>
              </div>
            </Accordion.Item.Header>
            <Accordion.Item.Content>
              <MainRateWidget
                values={values}
                stickyQuote={stickyQuote}
                result={result}
                main={main}
                quote={quote}
                broker={broker}
                updateValues={updateValues}
                showPurposeError={showPurposeError}
                showPurposeErrorMessage={showPurposeErrorMessage}
                showPurposeOtherError={showPurposeOtherError}
                showPurposeOtherErrorMessage={showPurposeOtherErrorMessage}
                showAmountMinError={showAmountMinError}
                showAmountMaxError={showAmountMaxError}
              />
            </Accordion.Item.Content>
          </Accordion.Item>
        </Accordion>
      )}
      {!stickyQuote && (
        <MainRateWidget
          values={values}
          stickyQuote={stickyQuote}
          result={result}
          main={main}
          quote={quote}
          broker={broker}
          brokerFee={brokerFee}
          updateValues={updateValues}
          showPurposeError={showPurposeError}
          showPurposeErrorMessage={showPurposeErrorMessage}
          showPurposeOtherError={showPurposeOtherError}
          showPurposeOtherErrorMessage={showPurposeOtherErrorMessage}
          showAmountMinError={showAmountMinError}
          showAmountMaxError={showAmountMaxError}
          parentOnChangeEvent={parentOnChangeEvent}
          getFullSqUrl = {getFullSqUrl}
        />
      )}
    </>
  );
}

export default EstimateRateWidget;
